import { useCompareIsEqual } from "../../utils/useCompare";
import { isLayer } from "../validator/useLayerIdentity";
import useQueryCopySource from "../store/useStoreCopySource";
import useQueryParentLayer from "../store/useStoreLayerParent";
import useQueryLayerUsingOriginalSource from "../store/useStoreLayerUsingOriginalSource"
import useQueryOriginalSourceByLayer from "../store/useStoreOriginalSource";
import useQueryLinkingLayers from "../store/useStoreRefLayer";


const doUpdateValue = (targetLayer, layers, propertyPath, key, value) => {
    if (!layers) return;
    if (isLayer(value)) {
        layers.forEach((layer) => {
            if (layer === targetLayer) return;
            const copySource = useQueryCopySource(layer);
            const originByValue = useQueryOriginalSourceByLayer(value);
            const oldOrigin = useQueryOriginalSourceByLayer(copySource[key]);
            if (!originByValue || !oldOrigin) return;
            const isEqual = useCompareIsEqual(originByValue, oldOrigin, propertyPath, layer, key)
            if (!isEqual) {
                // copySource[key] = value;
                layer[key] = value;
            }
        })
    } else {
        layers.forEach((layer) => {
            if (layer === targetLayer) return;
            const copySource = useQueryCopySource(layer);
            const isEqual = useCompareIsEqual(value, copySource[key], propertyPath, layer, key)
            if (!isEqual) {
                layer[key] = value;
            }
        })

    }
}

const useUpdateLayerByOriginalSource = (propertyPath, originalSource, key, value, targetLayer) => {
    const layerUsingSource = useQueryLayerUsingOriginalSource(originalSource);
    const linkLayers = useQueryLinkingLayers(targetLayer);
    if (!layerUsingSource && !linkLayers) {
        return
    }

    // value = originalSource[key];

    doUpdateValue(targetLayer, linkLayers, propertyPath, key, value);
    doUpdateValue(targetLayer, layerUsingSource, propertyPath, key, value);
}

export default useUpdateLayerByOriginalSource;